import axios from 'axios'
import { apiUrl } from './url'

const fetchData = axios.create({
  baseURL: apiUrl,
  withCredentials: true,
})

export default fetchData
